import { useState, useEffect } from "react";
import { changeLogInstanceTypes, changeLogType } from "../../../@types/components/changeLog.types";
import { Member } from "../../../@types/member.types";
import { Paycheck } from "../../../@types/paycheck.types";
import ROLES from "../../../constants/roles";
import initCapitalize from "../../../utils/commonFunctions/initCapitalize";
import prefixCharacterAddition from "../../../utils/commonFunctions/prefixCharacterAddition";

import "./memberStatusInformation.css";

const MemberStatusInformation = ({ memberInstance }: any) => {
	// console.log("=======memberInstance=====>", memberInstance);
	const [member, setMember] = useState<any>();
	const [memberStatusInformation, setMemberStatusInformation] = useState<any>();

	useEffect(() => {
		if (memberInstance)
			setMember(
				Object.assign(
					{},
					{
						...memberInstance
					}
				)
			);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [memberInstance]);

	// console.log("Log Data", member);

	useEffect(() => {
		setMemberStatusInformation(
			Object.assign(
				{},
				{
					role: member?.role,
					employee_status: member?.employee_status
						? initCapitalize(member?.employee_status)
						: member?.employee_status,
					dependent_status: member?.dependent_status
						? initCapitalize(member?.dependent_status)
						: member?.dependent_status
				}
			)
		);
	}, [member?.dependent_status, member?.employee_status, member?.role]);

	return (
		<div className="member-status-information-container">
			<span className="member-status-text">
				{memberStatusInformation?.role === ROLES.employee
					? "Employee Status: "
					: memberStatusInformation?.role === ROLES.dependent
					? "Dependent Status: "
					: null}
			</span>
			{memberStatusInformation?.employee_status === "Active" &&
			memberStatusInformation?.role === ROLES.employee ? (
				<span className="member-status-active">
					{memberStatusInformation?.role === ROLES.employee
						? memberStatusInformation?.employee_status
						: memberStatusInformation?.role === ROLES.dependent
						? memberStatusInformation?.dependent_status
						: null}
				</span>
			) : memberStatusInformation?.employee_status === "Inactive" &&
			  memberStatusInformation?.role === ROLES.employee ? (
				<span className="member-status-inactive">
					{memberStatusInformation?.role === ROLES.employee
						? "Not Yet Registered"
						: memberStatusInformation?.role === ROLES.dependent
						? memberStatusInformation?.dependent_status
						: null}
				</span>
			) : memberStatusInformation?.employee_status === "Relieved" &&
			  memberStatusInformation?.role === ROLES.employee ? (
				<>
					<span className="member-status-relieved">
						{memberStatusInformation?.role === ROLES.employee
							? memberStatusInformation?.employee_status
							: memberStatusInformation?.role === ROLES.dependent
							? memberStatusInformation?.dependent_status
							: null}
					</span>
					&nbsp;
					<span style={{ fontWeight: "bold" }}>
						Term Code:{" "}
						<span
							className="member-status-relieved"
							title={memberInstance?.term_reason ? memberInstance.term_reason : "NA"}
							style={{ cursor: "pointer" }}
						>
							{memberInstance.term_code ? memberInstance.term_code : "NA"}
						</span>
					</span>
				</>
			) : null}
		</div>
	);
};

export default MemberStatusInformation;
